import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Center,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Input,
  Heading,
  Flex,
  Textarea,
  NumberInput,
  NumberInputField,
  NumberIncrementStepper,
  NumberInputStepper,
  NumberDecrementStepper,
  Button,
  CircularProgress,
  useToast
} from "@chakra-ui/react";
import { useState } from "react";
import { DeployContract, provider_Signer } from "../../../utility/Ether";
import { useDispatch, useSelector } from "react-redux";
import { setProvider, setSigner } from "../../../Store/data";


const CustomInput = ({ holder, handleChange,value,type }) => {
  return (
    <Input
      variant={"outline"}
      _hover={{}}
      isRequired
      _focusVisible={{}}
      value={value}
      fontFamily={"poppins"}
      placeholder={holder}
      type={type}
      onChange={handleChange}
    />
  );
};


const Form = () => {
  const toast = useToast();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [numberOfTickets, setNumberOfTickets] = useState("");
  const [Uri, setUri] = useState("");
  const [Logo, setLogo] = useState("");
  const dispatch = useDispatch();
  const [loadingFlag, setFlag] = useState(false);
  const [showToast,setShowToast] = useState({
    type:"",
    flag:false
  })
  const handleChangeName = (e) => {
    console.log(e.target.value);
    setName(e.target.value);
  };

  const handleChangeDescription = (e) => {
    console.log(e.target.value);

    setDescription(e.target.value);
  };
  const handleChangeLogo = (e) => {
    console.log(e.target.value);

    setLogo(e.target.value);
  };
  const handleChangePrice = (e) => {
    console.log(e.target.value);

    setPrice(e.target.value);
  };
  const handleChangeTickets = (e) => {
    console.log(e.target.value);

    setNumberOfTickets(Number(e.target.value));
  };

  const handleChangeUri = (e) => {
    console.log(e.target.value);

    setUri(e.target.value);
  };

  const initiateDeployment = () => {

    setFlag(true);
    provider_Signer().then(async (res) => {
      console.log(res.signer);
      console.log(res.provider);

      dispatch(setSigner(JSON.stringify(res.signer)))
      dispatch(setProvider(JSON.stringify(res.provider)))

      let data = {
        title: name,
        price: price,
        url: Uri,
        size: numberOfTickets,
      };
      

      DeployContract(res.signer, res.provider, data)
        .then((res) => {
          console.log(res);
         
          
      toast({
        title: 'Event Created Successfully',
        status: 'success',
        duration: 9000,
        isClosable: true,
        position:"top-right"
      })
      toast({
        title: 'Contract Deployed Successfully',
        description: "use EtherScan to see your contract",
        status: 'success',
        duration: 9000,
        isClosable: true,
        position:"top-right"
      })
      

        })
        .catch((err) => {
          console.log(err);
          console.log(err.code);
          console.log(err.Error);

          if(err.code == "ACTION_REJECTED"){

            toast({
              title: 'Request Rejected',
              description: "MetaMask Request Rejected by User",
              status: 'error',
              duration: 9000,
              isClosable: true,
              position:"top-right"
            })
           
          }
        })
        .finally(() => {
          setFlag(false);
          // console.log("disable")
        });
    });
  };
  return (
    <>
      <Flex rowGap={"10px"} direction={"column"}>
        {/* TextInput Name */}
        <Box>
          <Text variant={"InputHeader"}>Name</Text>
          <CustomInput  holder={"Name"} value={name} handleChange={handleChangeName} />
        </Box>

        {/* Description TextArea */}
        <Box>
          <Text variant={"InputHeader"}>Description</Text>
          <Textarea
          value={description}
            placeholder="Description"
            variant={"InputModalTextArea"}
            onChange={handleChangeDescription}
          ></Textarea>
        </Box>

        {/* Input date */}
        {/* <Box>
          <Text variant={"InputHeader"}>Date</Text>
          <CustomInput value={Logo} holder={"Date"} type={"date"} handleChange={e=>{console.log(e.target.value)}} />
        </Box> */}

        {/* Input Logo URL */}
        <Box>
          <Text variant={"InputHeader"}>Logo</Text>
          <CustomInput value={Logo} holder={"Logo"} handleChange={handleChangeLogo} />
        </Box>

        {/* Input URI */}
        <Box>
          <Text variant={"InputHeader"}>URI</Text>
          <CustomInput value={Uri} holder={"URI"} handleChange={handleChangeUri} />
        </Box>

        {/* Number of Ticket input */}
        <Box>
          <Text variant={"InputHeader"} inputMode={"numeric"}>
            Number of Tickets
          </Text>
          <NumberInput variant={"outline"}>
            <NumberInputField
            value={numberOfTickets}
              placeholder="Number of Tickets"
              _hover={{}}
              _focusVisible={{}}
              fontFamily={"poppins"}
              onChange={handleChangeTickets}
            />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </Box>

        {/* Price input  */}
        <Box>
          <Text variant={"InputHeader"}>Price</Text>
          <NumberInput variant={"outline"}>
            <NumberInputField
              placeholder="Price"
              _hover={{}}
              value={price}
              _focusVisible={{}}
              fontFamily={"poppins"}
              onChange={handleChangePrice}
            />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </Box>
      </Flex>

      {/*  Create Event Button */}
      <Flex justify={"flex-end"} p="40px 0 20px 0">
        <Box>
          <Button
            isLoading={loadingFlag}
            fontFamily={"poppins"}
            loadingText="Deploying"
            variant="solid"
            opacity="1"
            colorScheme="#7950DD"
            color="white"
            bgColor={"#7950DD"}
            _hover={{
              bg: "#7950DD",
            }}
            onClick={initiateDeployment}
          >
            {!loadingFlag ? "Create Event" : "Deploying"}
          </Button>
        </Box>
      </Flex>
    </>
  );
};
const InputModal = (isOpen, onOpen, onClose) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay 
                bg='none'
                backdropFilter='auto'
                backdropInvert='80%'
                backdropBlur='2px'        
        >
          <ModalContent>
            <ModalHeader>
              <Center>
                <Text variant={"body"}>Event Details</Text>
              </Center>
              <ModalCloseButton />
            </ModalHeader>
            <ModalBody>
              <Box>{<Form />}</Box>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
};

export { InputModal };
